<template>
   <b-form ref="labelForm" @submit.prevent="submitForm" v-bind:class="[{ busy: busy}, 'opacity-transition']">
      <pb-spinner v-if="busy"></pb-spinner>
      <label for="example-datepicker">Choose a date</label>
      <b-form-datepicker reset-button :min="new Date()" v-model="orderPositionUpdate.confirmedDeliveryDate"
                         class="mb-2 secondary"></b-form-datepicker>
      <label for="example-datepicker">Order Info</label>
      <b-form-textarea rows="3" no-auto-shrink class="mb-2 h-auto secondary"
                       v-model="orderPositionUpdate.deliveryComment">
      </b-form-textarea>
   </b-form>
</template>

<script>

import {HTTP} from "@shared/_helpers/http";

export default {
   name: 'EditForm',
   props: {
      supplierId: {
         type: String,
         required: true
      },
      orderPositionUpdate: {
         type: Object,
         required: true
      }
   },
   data() {
      return {
         busy: false
      }
   },
   methods: {
      submit() {
         this.$refs.labelForm.submit();
      },
      submitForm(event) {
         this.busy = true;
         event.preventDefault();
         HTTP.post(`/supplier/${this.supplierId}/order/${this.orderPositionUpdate.id}`, {
            ...this.orderPositionUpdate,
            supplierId: this.supplierId
         })
             .then(() => this.$emit('submitted')
             ).catch(error => {
            console.log(error);
         }).finally(() => {
            this.busy = false;
         });
      }
   }
}
</script>

